import React, { useState } from "react";
import { Container } from "@mui/material";
// import CloseBtn from '../Images/close btn.png';
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import OutlinedInput from "@mui/material/OutlinedInput";
import Box from "@mui/material/Box";
import { useEffect } from "react";
import { useDriverSignupMutation } from "../../api/driver";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
function DeliveryDriver() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({});
  const [getSignUp, { isLoading }] = useDriverSignupMutation();

  // useEffect(() => {
  //   localStorage.removeItem("token");
  //   localStorage.removeItem("user");
  // }, []);

  const handleSubmitForm = () => {
    console.log(userData);
    getSignUp(userData).then((res) => {
      console.log("res", res);
      if (res.error) { Swal.fire("Failed!", res.error.data.message); }
      else if (res.data) {
        Swal.fire("Success!", res.data.message);
        navigate("/");
      }
    });
  };

  return (
    <>
      <Container
        maxWidth
        sx={{
          display: "flex",
          backgroundColor: "#F9FFFF",
          justifyContent: {
            lg: "right",
            md: "right",
            sm: "center",
            xs: "center",
          },
          backgroundImage: "url(./images/IllustrationsBg.svg)",
          backgroundRepeat: "no-repeat",
          // width: "100%",
          // height: "1021px",
          // height: "100vh",
          backgroundSize: {
            xl: "cover",
            lg: "cover",
            md: "contain",
            sm: "contain",
          },
          backgroundPosition: "center",
          // border: "1px solid red",
        }}
      >
        {/* <Box className="btnContainer" sx={{ marginTop: 3 ,border:"1px solid red" }}>
          <Button><img src={CloseBtn} /></Button> 
        </Box> */}
        {/* <Box sx={{ my: 5, display: "flex", justifyContent: "center",border:"1px solid blue" }}> */}
        <Box
          sx={{
            boxSizing: "border-box",
            padding: "24px",
            width: { lg: "42%", md: "50%", sm: "80%", xs: "100%" },
            height: "720px",
            backgroundColor: "#ffff",
            border: "1px solid  #E1E1E6",
            borderRadius: "4px",
            my: 2,
            // border: "1px solid red",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontFamily: "Outfit",
                fontStyle: "normal",
                fontWeight: "600",
                fontSize: { lg: "32px", md: "32px", sm: "20px", xs: "20px" },
              }}
            >
              Become a Delivery Driver
            </Typography>
            <Typography
              sx={{
                fontFamily: "Outfit",
                fontStyle: "normal",
                fontWeight: "400",
                fontSize: "16px",
                lineHeight: "160%",
                letterSpacing: "0.015em",
                letterSpacing: "#545359",
              }}
            >
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry
            </Typography>
          </Box>
          <Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>

              <Box>
                <Typography
                  sx={{
                    fontFamily: "Outfit",
                    fontSyle: "normal",
                    fontWeight: "600",
                    fontSize: "20px",
                    lineHeight: "140%",
                    letterSpacing: "0.015em",
                    color: "#1A1824;",
                    // display: "inline-block",
                  }}
                >
                  First Name
                </Typography>
                <OutlinedInput
                  placeholder="Your first name"
                  sx={{
                    width: { lg: "100%", md: "95%", sm: "90%", xs: "50%" },
                    height: "56px",
                    backgroundColor: "#F6F6F6;",
                    border: "1px solid #E1E1E6",
                    borderRadius: "4px",
                  }}
                  onChange={(e) =>
                    setUserData({ ...userData, firstName: e.target.value })
                  }
                />
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontFamily: "Outfit",
                    fontSyle: "normal",
                    fontWeight: "600",
                    fontSize: "20px",
                    lineHeight: "140%",
                    letterSpacing: "0.015em",
                    color: "#1A1824;",
                    // position: "relative",
                    // right: "130px",
                  }}
                >
                  Last Name
                </Typography>

                <OutlinedInput
                  placeholder="Your last name"
                  sx={{
                    width: { lg: "100%", md: "95%", sm: "90%", xs: "50%" },
                    height: "56px",
                    backgroundColor: "#F6F6F6;",
                    border: "1px solid #E1E1E6",
                    borderRadius: "4px",
                    // marginLeft: "20px",
                  }}
                  onChange={(e) =>
                    setUserData({ ...userData, lastName: e.target.value })
                  }
                />
              </Box>
            </Box>
            <Box>

              <Typography
                sx={{
                  fontFamily: "Outfit",
                  fontSyle: "normal",
                  fontWeight: "600",
                  fontSize: "20px",
                  lineHeight: "140%",
                  letterSpacing: "0.015em",
                  color: "#1A1824;",
                  marginTop: 1,
                }}
              >
                Email
              </Typography>
              <OutlinedInput
                placeholder="Enter your email"
                sx={{
                  width: { lg: "100%", md: "100%", sm: "90%", xs: "80%" },
                  height: "56px",
                  backgroundColor: "#F6F6F6;",
                  border: "1px solid #E1E1E6",
                  borderRadius: "4px",
                }}
                onChange={(e) =>
                  setUserData({ ...userData, email: e.target.value })
                }
              />
              <Typography
                sx={{
                  fontFamily: "Outfit",
                  fontSyle: "normal",
                  fontWeight: "600",
                  fontSize: "20px",
                  lineHeight: "140%",
                  letterSpacing: "0.015em",
                  color: "#1A1824;",
                  marginTop: 1,
                }}
              >
                Password
              </Typography>
              <OutlinedInput
                placeholder="Enter your password"
                sx={{
                  width: { lg: "100%", md: "100%", sm: "90%", xs: "80%" },
                  height: "56px",
                  backgroundColor: "#F6F6F6;",
                  border: "1px solid #E1E1E6",
                  borderRadius: "4px",
                }}
                type="password"
                onChange={(e) =>
                  setUserData({ ...userData, password: e.target.value })
                }
              />

              <Typography
                sx={{
                  fontFamily: "Outfit",
                  fontSyle: "normal",
                  fontWeight: "600",
                  fontSize: "20px",
                  lineHeight: "140%",
                  letterSpacing: "0.015em",
                  color: "#1A1824;",
                  marginTop: 1,
                }}
              >
                Phone Number
              </Typography>
              <OutlinedInput
                type="number"
                placeholder="+1000 000 000"
                sx={{
                  width: { lg: "100%", md: "100%", sm: "90%", xs: "80%" },
                  height: "56px",
                  backgroundColor: "#F6F6F6;",
                  border: "1px solid #E1E1E6",
                  borderRadius: "4px",
                }}
                onChange={(e) =>
                  setUserData({ ...userData, phone: e.target.value })
                }
              />
              <Typography
                sx={{
                  fontFamily: "Outfit",
                  fontSyle: "normal",
                  fontWeight: "600",
                  fontSize: "20px",
                  lineHeight: "140%",
                  letterSpacing: "0.015em",
                  color: "#1A1824;",
                  marginTop: 1,
                }}
              >
                City you'll drive in
              </Typography>
              <OutlinedInput
                placeholder="Enter your city name"
                sx={{
                  width: { lg: "100%", md: "100%", sm: "90%", xs: "80%" },
                  height: "56px",
                  backgroundColor: "#F6F6F6;",
                  border: "1px solid #E1E1E6",
                  borderRadius: "4px",
                }}
                onChange={(e) =>
                  setUserData({ ...userData, city: e.target.value })
                }
              />
              <Typography
                sx={{
                  fontFamily: "Outfit",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "16px",
                  lineHeight: "160%",
                  letterSpacing: "0.015em",
                  color: "#545359;",
                  marginTop: 1,
                }}
              >
                By procceeding. I Agree to Uber’s Terms of Use and acknowledge
                that i have read the Privacy Policy
              </Typography>
              <Button
                sx={{
                  paddding: "11px 20px",
                  width: { lg: "100%", md: "100%", sm: "90%", xs: "80%" },
                  height: "48px",
                  backgroundColor: "#2B817B;",
                  borderRadius: "6px",
                  color: "white",
                  marginTop: 1,
                }}
                onClick={handleSubmitForm}
              >
                {isLoading ? "Loading..." : "Register as Driver"}
              </Button>
            </Box>
          </Box>

        </Box>
        {/* </Box> */}
      </Container>
    </>
  );
}

export default DeliveryDriver;
